<div class='ili-panel contactus_panel'>
<span class="txt-email-notes">Separate multiple email addresses with a comma followed by a space</span>
<div class="confirmation_text_block"><input type="text" [(ngModel)]="block.data.email" placeholder="To email address" class="form-control input-sm url_block_url"></div>
</div>
